import { useState, useCallback } from 'react';

export interface ClientFormData {
  // Informations personnelles
  civility: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  address: string;
  wilaya: string;
  city: string;

  // Critères de recherche
  propertyType: string;
  transactionType: 'sale' | 'rent' | 'short-rent' | '';
  minBudget: string;
  maxBudget: string;
  minArea: string;
  minRooms: string;
  criteria: Record<string, boolean>;

  // Notes et suivi
  notes: string;
  agent: string;
  interestLevel: 'very-interested' | 'interested' | 'to-contact';
}

const initialFormData: ClientFormData = {
  civility: '',
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  address: '',
  wilaya: '',
  city: '',
  propertyType: '',
  transactionType: '',
  minBudget: '',
  maxBudget: '',
  minArea: '',
  minRooms: '',
  criteria: {},
  notes: '',
  agent: '',
  interestLevel: 'interested',
};

export const useClientForm = (initialData?: Partial<ClientFormData>) => {
  const [formData, setFormData] = useState<ClientFormData>(() => {
    if (initialData) {
      return { ...initialFormData, ...initialData };
    }
    return initialFormData;
  });

  const handleInputChange = useCallback((
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    
    console.log('📝 handleInputChange appelé:', { name, value, type });
    
    setFormData(prev => {
      // Gestion spéciale pour les critères imbriqués
      if (name.startsWith('criteria.')) {
        const criteriaKey = name.split('.')[1];
        console.log('📋 Mise à jour critère:', criteriaKey, 'valeur:', type === 'checkbox' ? (e.target as HTMLInputElement).checked : value);
        return {
          ...prev,
          criteria: {
            ...prev.criteria,
            [criteriaKey]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
          }
        };
      }

      // Gestion normale pour les autres champs
      const newData = {
        ...prev,
        [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
      };
      console.log('📊 Nouvelles données formData:', newData);
      return newData;
    });
  }, []);

  const updateFormData = useCallback((updates: Partial<ClientFormData>) => {
    setFormData(prev => ({ ...prev, ...updates }));
  }, []);

  return {
    formData,
    handleInputChange,
    updateFormData,
  };
};